export const getCommaSeperated = (val, currency = true) => {
    const options = {
        style: 'decimal',  // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
    const formattedWithOptions = val?.toLocaleString('en-US', options);
    if(currency) {
        return '$' + formattedWithOptions
    }
    return formattedWithOptions
}

export const getuuid = (prefix) => {
    return `${prefix?.toUpperCase()}-${+new Date()}`
}